module.exports = __webpack_public_path__ + "media/fonts/Oricons-9fc127dfda6c7cc25b1fc7ffc96a22ac.ttf";